import src from "IMAGE";
export default { src, width: 585, height: 466, blurWidth: 0, blurHeight: 0};
